import React from "react";
import { statusClass } from "@/lib/utils-app";
import OSCard from "./OSCard";

/**
 * Kanban column with drop zone + count badge + status hint.
 * Pure: receives orders + hover state + card interaction handlers.
 */
export default function KanbanColumn({
  column,             // { key, tone, hint }
  orders,             // OS[] for this column
  loading,
  isHover,
  dragOs,
  onDragOver,
  onDragLeave,
  onDrop,
  onCardDragStart,
  onCardDragEnd,
  onCardClick,
  onCardAccept,
}) {
  return (
    <div
      onDragOver={(e) => onDragOver(e, column.key)}
      onDragLeave={(e) => onDragLeave(e, column.key)}
      onDrop={(e) => onDrop(e, column.key)}
      className={`border rounded-2xl p-3 min-h-[400px] transition-colors ${isHover ? "bg-neutral-900/5 border-neutral-900 border-dashed" : "bg-neutral-100/60 border-neutral-200"}`}
      data-testid={`board-col-${column.tone}`}
    >
      <div className="flex items-center justify-between px-2 py-1.5 mb-2">
        <div><span className={statusClass(column.key)}>● {column.key}</span></div>
        <div className="text-xs font-mono font-bold text-neutral-500">{orders.length}</div>
      </div>
      <div className="text-[10px] uppercase tracking-widest text-neutral-500 font-bold px-2 mb-3">{column.hint}</div>

      <div className="space-y-2">
        {loading && <div className="text-xs text-neutral-500 p-4">Carregando…</div>}
        {!loading && orders.length === 0 && (
          <div className={`text-xs border border-dashed rounded-lg p-6 text-center ${isHover ? "border-neutral-900 text-neutral-900" : "border-neutral-300 text-neutral-400"}`}>
            {isHover ? "Solte aqui" : "Sem cards"}
          </div>
        )}
        {orders.map((o) => (
          <OSCard
            key={o.os_code}
            os={o}
            columnKey={column.key}
            isDragging={dragOs?.os_code === o.os_code}
            onDragStart={onCardDragStart}
            onDragEnd={onCardDragEnd}
            onClick={onCardClick}
            onAccept={onCardAccept}
          />
        ))}
      </div>
    </div>
  );
}
